import { Button } from "antd";
import type { LeadItem, LeadStatus } from "../types/lead.types";
import { formatLeadActivity, getLeadManagerLabel } from "../utils/lead-display";
import { LeadSourceBadge } from "./LeadSourceBadge";

type LeadsTableProps = {
	leads: LeadItem[];
	statuses: LeadStatus[];
	onOpenLead: (lead: LeadItem) => void;
};

export function LeadsTable({ leads, statuses, onOpenLead }: LeadsTableProps) {
	const getStatus = (statusId: LeadItem["statusId"]) =>
		statuses.find((status) => status.id === statusId);

	return (
		<div className="crm-card crm-table-card crm-leads-table-card">
			<div className="crm-table-wrap">
				<table className="crm-table">
					<thead>
						<tr>
							<th>Lead</th>
							<th>Telefon</th>
							<th>Manba</th>
							<th>Bino</th>
							<th>Holat</th>
							<th>Mas'ul</th>
							<th />
						</tr>
					</thead>
					<tbody>
						{leads.map((lead) => {
							const status = getStatus(lead.statusId);

							return (
								<tr key={lead.id} onClick={() => onOpenLead(lead)}>
									<td>
										<strong>{lead.name}</strong>
										<span className="crm-table-sub">{formatLeadActivity(lead.lastActivity)}</span>
									</td>
									<td data-label="Telefon">{lead.phone}</td>
									<td data-label="Manba">
										<LeadSourceBadge source={lead.source} />
									</td>
									<td data-label="Bino">{lead.buildingName || "-"}</td>
									<td data-label="Holat">
										<span className="crm-status-badge" style={{ color: status?.color }}>
											<span />
											{status?.name}
										</span>
									</td>
									<td data-label="Mas'ul">
										<span className="crm-lead-manager compact">
											<i>{lead.managerInitials}</i>
											{getLeadManagerLabel(lead)}
										</span>
									</td>
									<td>
										<Button
											className="crm-open-btn"
											onClick={(event) => {
												event.stopPropagation();
												onOpenLead(lead);
											}}
											size="small"
										>
											Ochish
										</Button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			<div className="crm-table-foot">
				<span>Jami {leads.length} ta lead</span>
			</div>
		</div>
	);
}
